import { AfterViewInit, Component, Input, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { CustomModalComponent } from 'hig-ng-lib';
import { Subject, takeUntil } from 'rxjs';
import { AppConfig } from '../../../../config/app-config';
import {
    CLAIM_LIST_COLUMN_VALUE1,
    MODIFY_COLUMN_DISPLAY_CLAIM_SUB_TITLE,
    MODIFY_COLUMN_DISPLAY_CLAIM_TITLE,
    PRINT_DUPLICATE_COL_ERROR
} from '../../../../treo.properties';
import { LoaderService } from '../../../core/services/loading.service';
import { SharedService } from '../../../core/services/shared.service';
import { OshaService } from '../../osha-reporting/osha.service';
import { ClaimsService } from '../claims.service';

@Component({
    selector: 'app-modify-column-display-modal',
    templateUrl: './modify-column-display-modal.component.html',
    standalone: false
})
export class ModifyColumnDisplayModalComponent implements OnInit, AfterViewInit {
    @Input() showModify: boolean = false;
    @Input() hideModifyFunction = () => {};
    @Input() receivedArray: any[] = [];
    @Input() runListRespArray: any[] = [];
    @Input() context: string; // e.g., 'claims' or 'osha'
    ModifyColumnDisplayTitle: any;
    ModifyColumnDisplaySubTitle: string;
    ModifyClaimNumberSubTitle: string;
    ModifyColumnDisplayForm: UntypedFormGroup;
    transformedResp: any[] = [];
    saveBtnFuncResp: any[] = [];
    runListArray: any[] = [];
    apiResponse: any;
    result: any;
    private destroy$ = new Subject<void>();

    columnTwoSelectionField = {
        type: 'select',
        label: '',
        name: 'columnTwoSelection',
        id: 'claim-lists-column-two-selection-ts',
        className: 'm-1',
        showField: true,
        isTealiumAllowed: false,
        placeHolder: '',
        options: []
    };
    columnThreeSelectionField = {
        type: 'select',
        label: '',
        name: 'columnThreeSelection',
        id: 'claim-lists-column-three-selection-ts',
        className: 'm-1',
        showField: true,
        isTealiumAllowed: false,
        placeHolder: '',
        options: []
    };
    columnFourSelectionField = {
        type: 'select',
        label: '',
        name: 'columnFourSelection',
        id: 'claim-lists-column-four-selection-ts',
        className: 'm-1',
        showField: true,
        isTealiumAllowed: false,
        placeHolder: '',
        options: []
    };
    columnFiveSelectionField = {
        type: 'select',
        label: '',
        name: 'columnFiveSelection',
        id: 'claim-lists-column-five-selection-ts',
        className: 'm-1',
        showField: true,
        isTealiumAllowed: false,
        placeHolder: '',
        options: []
    };
    columnSixSelectionField = {
        type: 'select',
        label: '',
        name: 'columnSixSelection',
        id: 'claim-lists-column-six-selection-ts',
        className: 'm-1',
        showField: true,
        isTealiumAllowed: false,
        placeHolder: '',
        options: []
    };
    columnSevenSelectionField = {
        type: 'select',
        label: '',
        name: 'columnSevenSelection',
        id: 'claim-lists-column-seven-selection-ts',
        className: 'm-1',
        showField: true,
        isTealiumAllowed: false,
        placeHolder: '',
        options: []
    };

    @ViewChild('modifyColumnDisplayModal', { static: true }) modifyColumnDisplayModalRef: CustomModalComponent;
    @ViewChild('cancelBtnTemplate', { static: true }) cancelBtnTemplate;
    @ViewChild('saveSelectioneBtnTemplate', { static: true }) saveSelectioneBtnTemplate;
    @ViewChild('columnTwoSelection') columnTwoSelection;
    @ViewChild('columnThreeSelection') columnThreeSelection;
    @ViewChild('columnFourSelection') columnFourSelection;
    @ViewChild('columnFiveSelection') columnFiveSelection;
    @ViewChild('columnSixSelection') columnSixSelection;
    @ViewChild('columnSevenSelection') columnSevenSelection;
    public JSON = JSON;
    constructor(
        private fb: UntypedFormBuilder,
        private claimService: ClaimsService,
        private loaderService: LoaderService,
        private sharedService: SharedService,
        private oshaService: OshaService
    ) {}

    cancelBtnConfig = AppConfig.cancelBtnConfig;
    saveSelectioneBtnConfig = AppConfig.saveSelectioneBtnConfig;
    modifyColumnDisplayModalMsgFieldConfig = AppConfig.modifyColumnDisplayModalMsgFieldConfig;
    printDuplicateColError = PRINT_DUPLICATE_COL_ERROR;

    ngAfterViewInit(): void {
        this.cancelBtnTemplate.field = this.cancelBtnConfig;
        this.saveSelectioneBtnTemplate.field = this.saveSelectioneBtnConfig;
        this.columnTwoSelection.field = this.columnTwoSelectionField;
        this.columnThreeSelection.field = this.columnThreeSelectionField;
        this.columnFourSelection.field = this.columnFourSelectionField;
        this.columnFiveSelection.field = this.columnFiveSelectionField;
        this.columnSixSelection.field = this.columnSixSelectionField;
        if (this.columnSevenSelection?.field) {
            this.columnSevenSelection.field = this.columnSevenSelectionField;
        }
        if (this.context === 'osha') {
            this.loadOshaDropdownData();
        } else {
            this.loadDropdownData();
        }
    }

    ngOnInit() {
        this.ModifyColumnDisplayTitle = MODIFY_COLUMN_DISPLAY_CLAIM_TITLE;
        this.ModifyColumnDisplaySubTitle = MODIFY_COLUMN_DISPLAY_CLAIM_SUB_TITLE;
        this.ModifyClaimNumberSubTitle = CLAIM_LIST_COLUMN_VALUE1;

        this.ModifyColumnDisplayForm = this.fb.group(
            {
                columnOneSelection: [''],
                columnTwoSelection: [''],
                columnThreeSelection: [''],
                columnFourSelection: [''],
                columnFiveSelection: [''],
                columnSixSelection: [''],
                columnSevenSelection: ['']
            },
            { validators: this.duplicateValidator }
        );
        this.sharedService.apiResponse$.pipe(takeUntil(this.destroy$)).subscribe((response) => {
            if (response) {
                this.apiResponse = response;
                if (this.context === 'osha') {
                    this.loadOshaDropdownData();
                } else {
                    this.loadDropdownData();
                }
            }
        });
    }

    ngOnChanges() {
        if (this.showModify) {
            this.modifyColumnDisplayModalRef.show();
        } else {
            this.modifyColumnDisplayModalRef.hide();
        }
    }

    duplicateValidator(formGroup: UntypedFormGroup): { [key: string]: any } | null {
        const valuesArray = Object.values(formGroup.value).filter((val) => val !== null && val !== '');
        const duplicateValues = valuesArray.filter((value, index, self) => self.indexOf(value) !== index);
        return duplicateValues.length > 0 ? { duplicates: true } : null;
    }

    showModal() {
        this.modifyColumnDisplayModalRef.show();
    }

    hideModal(modalName: string) {
        if (modalName !== 'modalClose') {
            this.modifyColumnDisplayModalRef.hide();
        }

        this.result = this.findValue(this.transformedResp, this.apiResponse);

        this.hideModifyFunction();
        if (this.ModifyColumnDisplayForm) {
            this.ModifyColumnDisplayForm.get('columnTwoSelection').setValue(this.result?.[0]);
            this.ModifyColumnDisplayForm.get('columnThreeSelection').setValue(this.result?.[1]);
            this.ModifyColumnDisplayForm.get('columnFourSelection').setValue(this.result?.[2]);
            this.ModifyColumnDisplayForm.get('columnFiveSelection').setValue(this.result?.[3]);
            this.ModifyColumnDisplayForm.get('columnSixSelection').setValue(this.result?.[4]);
            this.ModifyColumnDisplayForm.get('columnSevenSelection').setValue(this.result?.[5]);
        }
    }

    loadOshaDropdownData() {
        if (!this.apiResponse) return;
        const dataPayload = {
            organizationId: this.loaderService.getItem('orgId'),
            applicationAccntDtlId: this.loaderService.getItem('appAccountDetailId'),
            actionType: 'CASE_MANAGEMENT',
            operation: 'MODIFY_COLUMNS_DISPLAY'
        };

        this.oshaService.getModifyDropdownData(dataPayload).subscribe({
            next: (resp: any) => {
                this.transformedResp = resp.modifyColumnDisplay.columnList.map((item) => ({
                    value: item.id,
                    label: item.name
                }));
                this.result = this.findValue(this.transformedResp, this.apiResponse);

                this.columnTwoSelectionField.options = [...this.transformedResp];
                this.columnThreeSelectionField.options = [...this.transformedResp];
                this.columnFourSelectionField.options = [...this.transformedResp];
                this.columnFiveSelectionField.options = [...this.transformedResp];
                this.columnSixSelectionField.options = [...this.transformedResp];
                this.ModifyColumnDisplayForm.get('columnTwoSelection').setValue(this.result?.[0]);
                this.ModifyColumnDisplayForm.get('columnThreeSelection').setValue(this.result?.[1]);
                this.ModifyColumnDisplayForm.get('columnFourSelection').setValue(this.result?.[2]);
                this.ModifyColumnDisplayForm.get('columnFiveSelection').setValue(this.result?.[3]);
                this.ModifyColumnDisplayForm.get('columnSixSelection').setValue(this.result?.[4]);
                this.loaderService.hideLoader();
            },
            error: (error) => {
                this.loaderService.hideLoader();
            }
        });
    }

    loadDropdownData() {
        const dataPayload = {
            claimInfo: {
                applicationAccntDtlId: this.loaderService.getItem('appAccountDetailId'),
                applctnUsrID: this.loaderService.getItem('applctnUserId'),
                orgnztnId: this.loaderService.getItem('orgId')
            },
            claimDetailType: 'MODIFY_COLUMN_DISPLAY',
            claimType: 'HARTFORD',
            actionType: 'RETRIEVE'
        };

        this.claimService.searchClaimDetailByClaimNumber(dataPayload).subscribe({
            next: (resp: any) => {
                this.transformedResp = resp.modifyColumnDisplay.columnList.map((item) => ({
                    value: item.id,
                    label: item.name
                }));

                this.result = this.findValue(this.transformedResp, this.apiResponse);

                this.columnTwoSelectionField.options = [...this.transformedResp];
                this.columnThreeSelectionField.options = [...this.transformedResp];
                this.columnFourSelectionField.options = [...this.transformedResp];
                this.columnFiveSelectionField.options = [...this.transformedResp];
                this.columnSixSelectionField.options = [...this.transformedResp];
                this.columnSevenSelectionField.options = [...this.transformedResp];
                this.ModifyColumnDisplayForm.get('columnTwoSelection').setValue(this.result?.[0]);
                this.ModifyColumnDisplayForm.get('columnThreeSelection').setValue(this.result?.[1]);
                this.ModifyColumnDisplayForm.get('columnFourSelection').setValue(this.result?.[2]);
                this.ModifyColumnDisplayForm.get('columnFiveSelection').setValue(this.result?.[3]);
                this.ModifyColumnDisplayForm.get('columnSixSelection').setValue(this.result?.[4]);
                this.ModifyColumnDisplayForm.get('columnSevenSelection').setValue(this.result?.[5]);
                this.loaderService.hideLoader();
            },
            error: (error) => {
                this.loaderService.hideLoader();
            }
        });
    }

    SaveSelectionBtn() {
        if(this.ModifyColumnDisplayForm.valid){
            if (this.context === 'osha') {
                this.saveBtnOshaAPiCall();
            } else {
                this.saveBtnApiCall();
            }
        }
    }

    saveBtnApiCall() {
        const dataPayload = {
            claimInfo: {
                applctnUsrID: this.loaderService.getItem('applctnUserId')
            },
            claimDetailType: 'MODIFY_COLUMN_DISPLAY',
            claimType: 'HARTFORD',
            actionType: 'UPDATE',
            modifyColumnDisplay: {
                mapColumns: {
                    '2': parseInt(this.ModifyColumnDisplayForm.controls['columnTwoSelection'].value),
                    '3': parseInt(this.ModifyColumnDisplayForm.controls['columnThreeSelection'].value),
                    '4': parseInt(this.ModifyColumnDisplayForm.controls['columnFourSelection'].value),
                    '5': parseInt(this.ModifyColumnDisplayForm.controls['columnFiveSelection'].value),
                    '6': parseInt(this.ModifyColumnDisplayForm.controls['columnSixSelection'].value),
                    '7': parseInt(this.ModifyColumnDisplayForm.controls['columnSevenSelection'].value)
                }
            }
        };

        this.claimService.modifyColumnSaveBtn(dataPayload).subscribe({
            next: (resp: any) => {
                this.saveBtnFuncResp = resp;
                this.loaderService.hideLoader();

                this.sharedService.triggerApiCall();
                this.sharedService.triggerApiCallWatchlist();
            },
            error: (error) => {
                this.loaderService.hideLoader();
            }
        });

        this.modifyColumnDisplayModalRef.hide();
    }

    mapColumns;

    saveBtnOshaAPiCall() {
        const dataPayload = {
            organizationId: this.loaderService.getItem('orgId'),
            applicationAccntDtlId: this.loaderService.getItem('appAccountDetailId'),
            actionType: 'CASE_MANAGEMENT',
            operation: 'MODIFY_UPDATED_COLUMNS',
            modifyColumnDisplay: {
                mapColumns: {
                    '2': parseInt(this.ModifyColumnDisplayForm.controls['columnTwoSelection'].value),
                    '3': parseInt(this.ModifyColumnDisplayForm.controls['columnThreeSelection'].value),
                    '4': parseInt(this.ModifyColumnDisplayForm.controls['columnFourSelection'].value),
                    '5': parseInt(this.ModifyColumnDisplayForm.controls['columnFiveSelection'].value),
                    '6': parseInt(this.ModifyColumnDisplayForm.controls['columnSixSelection'].value)
                }
            }
        };
        this.mapColumns=dataPayload.modifyColumnDisplay.mapColumns
        this.loaderService.showLoader();
        this.oshaService.modifyColumnSaveBtn(dataPayload).subscribe({
            next: (resp: any) => {
                this.saveBtnFuncResp = resp;
                this.loaderService.hideLoader();
                this.sharedService.triggerApiCall();
                this.sharedService.triggerApiCallWatchlist();
            },
            error: (error) => {
                this.loaderService.hideLoader();
            }
        });

        this.modifyColumnDisplayModalRef.hide();
    }

    findValue(array1: any[], array2: any[]): string[] {
        return array2
            ?.map((item2) => {
                const match = array1.find((item1) => item1.value == item2.columnId);
                return match ? match.value : null;
            })
            .filter((value) => value !== null);
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
